(function () {
  'use strict';

  var LIMIT = 10;
  var container, section, apiBase, productId;
  var offset = 0;
  var sort = 'newest';
  var total = 0;

  function init() {
    section = document.getElementById('product-reviews');
    if (!section) return;

    container = section.querySelector('[data-reviews-container]');
    apiBase = section.dataset.apiBase;
    productId = section.dataset.productId;

    if (!container || !productId) return;

    // Sort change
    var sortSelect = section.querySelector('[data-review-sort]');
    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        sort = this.value;
        offset = 0;
        container.innerHTML = '';
        fetchReviews();
      });
    }

    // Load more
    var loadMoreBtn = section.querySelector('[data-load-more-btn]');
    if (loadMoreBtn) {
      loadMoreBtn.addEventListener('click', function () {
        fetchReviews();
      });
    }

    // Write review modal
    initModal();
    initStarPicker();
    initForm();

    // Lazy load: fetch on scroll into view
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          if (entries[0].isIntersecting) {
            observer.disconnect();
            fetchReviews();
          }
        },
        { rootMargin: '200px' }
      );
      observer.observe(section);
    } else {
      fetchReviews();
    }
  }

  function fetchReviews() {
    var url =
      apiBase +
      '/api/reviews/public?shopify_product_id=' +
      productId +
      '&limit=' +
      LIMIT +
      '&offset=' +
      offset +
      '&sort=' +
      sort;

    var loadMoreWrap = section.querySelector('[data-reviews-load-more]');
    var loadMoreBtn = section.querySelector('[data-load-more-btn]');
    if (loadMoreBtn) loadMoreBtn.disabled = true;

    fetch(url)
      .then(function (res) {
        if (!res.ok) throw new Error('Failed to load reviews');
        return res.json();
      })
      .then(function (data) {
        // Remove skeleton on first load
        var skeletons = container.querySelectorAll('.reviews-skeleton');
        skeletons.forEach(function (s) {
          s.remove();
        });

        total = data.total || 0;
        var reviews = data.reviews || [];

        reviews.forEach(function (r) {
          container.appendChild(buildReviewCard(r));
        });

        offset += reviews.length;

        // Show/hide load more
        if (loadMoreWrap) {
          loadMoreWrap.style.display = offset < total ? '' : 'none';
        }
        if (loadMoreBtn) loadMoreBtn.disabled = false;
      })
      .catch(function (err) {
        // Remove skeleton
        var skeletons = container.querySelectorAll('.reviews-skeleton');
        skeletons.forEach(function (s) {
          s.remove();
        });

        // Show fallback message
        var msg = document.createElement('div');
        msg.className = 'reviews-empty';
        msg.innerHTML = '<p>Unable to load reviews right now. Please try again later.</p>';
        container.appendChild(msg);
      });
  }

  function buildReviewCard(review) {
    var card = document.createElement('div');
    card.className = 'review-item';

    var dateStr = '';
    if (review.created_at) {
      var d = new Date(review.created_at);
      var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
      dateStr = d.getDate() + ' ' + months[d.getMonth()] + ' ' + d.getFullYear();
    }

    var starsHtml = renderStarsHtml(review.rating || 5);

    var recommendHtml = '';
    var showNegative = review.recommend === false || (review.rating && review.rating <= 2);
    if (review.recommend === true && !showNegative) {
      recommendHtml =
        '<div class="review-item__recommend review-item__recommend--yes"><span class="review-item__recommend-icon">✓</span> Recommends this product</div>';
    } else if (showNegative) {
      recommendHtml =
        '<div class="review-item__recommend review-item__recommend--no"><span class="review-item__recommend-icon">✕</span> Does not recommend this product</div>';
    }

    var footerParts = [];
    if (review.reviewer_name) footerParts.push('<strong>' + escapeHtml(review.reviewer_name) + '</strong>');
    if (review.location) footerParts.push(escapeHtml(review.location));
    if (review.is_verified_purchase)
      footerParts.push('<span class="review-item__verified">✓ Verified Buyer</span>');

    card.innerHTML =
      '<div class="review-item__header">' +
      '<span class="review-stars">' +
      starsHtml +
      '</span>' +
      '</div>' +
      (review.title
        ? '<h3 class="review-item__title">' + escapeHtml(review.title) + '</h3>'
        : '') +
      (review.body
        ? '<p class="review-item__body">' + escapeHtml(review.body) + '</p>'
        : '') +
      buildPhotosHtml(review.media_urls) +
      recommendHtml +
      '<div class="review-item__footer">' +
      '<div class="review-item__author">' +
      footerParts.join(' <span class="review-item__separator">·</span> ') +
      '</div>' +
      (dateStr ? '<span class="review-item__date">' + dateStr + '</span>' : '') +
      '</div>';

    return card;
  }

  function renderStarsHtml(rating) {
    var html = '';
    for (var i = 1; i <= 5; i++) {
      var fill = i <= rating ? '#fbbf24' : '#d1d5db';
      html +=
        '<svg width="14" height="14" viewBox="0 0 20 20" fill="' +
        fill +
        '" aria-hidden="true"><path d="M10 1l2.39 4.84L17.8 6.7l-3.9 3.8.92 5.37L10 13.14l-4.82 2.73.92-5.37-3.9-3.8 5.41-.86L10 1z"/></svg>';
    }
    return html;
  }

  function buildPhotosHtml(mediaUrls) {
    if (!mediaUrls || !mediaUrls.length) return '';
    var html = '<div class="review-item__photos">';
    for (var i = 0; i < mediaUrls.length; i++) {
      html +=
        '<a href="' + mediaUrls[i] + '" target="_blank" rel="noopener">' +
        '<img src="' + mediaUrls[i] + '" alt="Review photo" class="review-item__photo" loading="lazy" width="80" height="80">' +
        '</a>';
    }
    html += '</div>';
    return html;
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  // ── Modal ──

  function initModal() {
    var openBtns = section.querySelectorAll('[data-review-form-open]');
    var modal = section.querySelector('[data-review-modal]');
    var closeBtns = section.querySelectorAll('[data-review-modal-close]');

    if (!modal) return;

    openBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        modal.style.display = '';
        modal.classList.add('modal--is-active');
        document.body.style.overflow = 'hidden';
        modal.scrollTop = 0;
      });
    });

    function closeModal() {
      modal.style.display = 'none';
      modal.classList.remove('modal--is-active');
      document.body.style.overflow = '';
    }

    closeBtns.forEach(function (btn) {
      btn.addEventListener('click', closeModal);
    });

    modal.addEventListener('click', function (e) {
      if (e.target === modal || e.target.classList.contains('modal__inner')) {
        closeModal();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('modal--is-active')) {
        closeModal();
      }
    });
  }

  // ── Star Picker ──

  function initStarPicker() {
    var picker = section.querySelector('[data-star-picker]');
    if (!picker) return;

    var stars = picker.querySelectorAll('[data-star]');
    var ratingInput = picker.parentElement.querySelector('input[name="rating"]');

    function setRating(val) {
      ratingInput.value = val;
      stars.forEach(function (s) {
        var starVal = parseInt(s.dataset.star, 10);
        s.setAttribute('fill', starVal <= val ? '#fbbf24' : '#d1d5db');
        s.setAttribute('aria-checked', starVal === val ? 'true' : 'false');
      });
    }

    stars.forEach(function (star) {
      star.addEventListener('click', function () {
        setRating(parseInt(this.dataset.star, 10));
      });
      star.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          setRating(parseInt(this.dataset.star, 10));
        }
      });
      star.addEventListener('mouseenter', function () {
        var val = parseInt(this.dataset.star, 10);
        stars.forEach(function (s) {
          s.setAttribute(
            'fill',
            parseInt(s.dataset.star, 10) <= val ? '#fbbf24' : '#d1d5db'
          );
        });
      });
    });

    picker.addEventListener('mouseleave', function () {
      var current = parseInt(ratingInput.value, 10);
      stars.forEach(function (s) {
        s.setAttribute(
          'fill',
          parseInt(s.dataset.star, 10) <= current ? '#fbbf24' : '#d1d5db'
        );
      });
    });
  }

  // ── Mobile input scroll fix ──

  function initMobileInputFix() {
    // Intentionally empty — iOS handles keyboard scroll natively.
    // The previous scrollIntoView hack caused the modal to jump on focus.
  }

  // ── Recommend Toggle ──

  function initRecommendToggle() {
    var btns = section.querySelectorAll('.review-form__recommend-btn');
    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        btns.forEach(function (b) { b.classList.remove('review-form__recommend-btn--active'); });
        btn.classList.add('review-form__recommend-btn--active');
      });
    });
  }

  // ── Photo Upload ──

  var uploadedMediaUrls = [];
  var MAX_PHOTOS = 3;
  var MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB
  var ALLOWED_TYPES = ['image/jpeg', 'image/png', 'image/webp'];

  function initPhotoUpload() {
    var uploadWrap = section.querySelector('[data-photo-upload]');
    if (!uploadWrap) return;

    var fileInput = uploadWrap.querySelector('[data-photo-input]');
    var addBtn = uploadWrap.querySelector('[data-photo-add-btn]');
    var previews = uploadWrap.querySelector('[data-photo-previews]');
    var errorEl = section.querySelector('[data-photo-error]');

    fileInput.addEventListener('change', function () {
      var files = Array.prototype.slice.call(this.files);
      this.value = '';
      errorEl.style.display = 'none';

      var remaining = MAX_PHOTOS - uploadedMediaUrls.length;
      if (remaining <= 0) {
        errorEl.textContent = 'Maximum ' + MAX_PHOTOS + ' photos allowed.';
        errorEl.style.display = '';
        return;
      }

      files = files.slice(0, remaining);

      for (var i = 0; i < files.length; i++) {
        var file = files[i];
        if (ALLOWED_TYPES.indexOf(file.type) === -1) {
          errorEl.textContent = 'Only JPEG, PNG, and WebP images are allowed.';
          errorEl.style.display = '';
          continue;
        }
        if (file.size > MAX_FILE_SIZE) {
          errorEl.textContent = 'Each photo must be under 5MB.';
          errorEl.style.display = '';
          continue;
        }
        uploadFile(file, previews, addBtn, errorEl);
      }
    });
  }

  function uploadFile(file, previews, addBtn, errorEl) {
    // Create preview
    var preview = document.createElement('div');
    preview.className = 'review-form__photo-preview review-form__photo-preview--uploading';

    var img = document.createElement('img');
    img.src = URL.createObjectURL(file);
    img.alt = 'Upload preview';
    preview.appendChild(img);

    var spinner = document.createElement('div');
    spinner.className = 'review-form__photo-spinner';
    preview.appendChild(spinner);

    previews.appendChild(preview);
    updateAddBtnVisibility(addBtn);

    // Upload
    var formData = new FormData();
    formData.append('images', file);

    var honeypotVal = section.querySelector('input[name="website"]').value;
    if (honeypotVal) formData.append('website', honeypotVal);

    fetch(apiBase + '/api/reviews/storefront/upload', {
      method: 'POST',
      body: formData,
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Upload failed');
        return res.json();
      })
      .then(function (data) {
        var url = data.urls && data.urls[0];
        if (!url) throw new Error('No URL returned');

        uploadedMediaUrls.push(url);
        preview.classList.remove('review-form__photo-preview--uploading');
        spinner.remove();

        // Use thumbnail for preview if available
        if (data.thumbnails && data.thumbnails[0]) {
          img.src = data.thumbnails[0];
        }

        // Add remove button
        var removeBtn = document.createElement('button');
        removeBtn.type = 'button';
        removeBtn.className = 'review-form__photo-remove';
        removeBtn.innerHTML = '✕';
        removeBtn.setAttribute('aria-label', 'Remove photo');
        removeBtn.addEventListener('click', function () {
          var idx = uploadedMediaUrls.indexOf(url);
          if (idx > -1) uploadedMediaUrls.splice(idx, 1);
          preview.remove();
          updateAddBtnVisibility(addBtn);
        });
        preview.appendChild(removeBtn);
      })
      .catch(function () {
        preview.remove();
        errorEl.textContent = 'Photo upload failed. Please try again.';
        errorEl.style.display = '';
        updateAddBtnVisibility(addBtn);
      });
  }

  function updateAddBtnVisibility(addBtn) {
    if (uploadedMediaUrls.length >= MAX_PHOTOS) {
      addBtn.classList.add('review-form__photo-add--hidden');
    } else {
      addBtn.classList.remove('review-form__photo-add--hidden');
    }
  }

  // ── Form Submit ──

  function initForm() {
    var form = section.querySelector('[data-review-form]');
    if (!form) return;
    initRecommendToggle();
    initMobileInputFix();
    initPhotoUpload();

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var errorEl = form.querySelector('[data-form-error]');
      var successEl = section.querySelector('[data-form-success]');
      errorEl.style.display = 'none';

      // Honeypot — bots fill this, real users don't
      var honeypotVal = form.querySelector('input[name="website"]').value;
      if (honeypotVal) return;

      var rating = parseInt(form.querySelector('input[name="rating"]').value, 10);
      if (!rating || rating < 1 || rating > 5) {
        errorEl.textContent = 'Please select a star rating.';
        errorEl.style.display = '';
        return;
      }

      // Block submit if photos are still uploading
      var uploading = section.querySelectorAll('.review-form__photo-preview--uploading');
      if (uploading.length > 0) {
        errorEl.textContent = 'Please wait for photos to finish uploading.';
        errorEl.style.display = '';
        return;
      }

      var payload = {
        shopify_product_id: productId,
        rating: rating,
        title: form.querySelector('input[name="title"]').value.trim(),
        body: form.querySelector('textarea[name="body"]').value.trim(),
        reviewer_name: form.querySelector('input[name="reviewer_name"]').value.trim(),
        reviewer_email: form.querySelector('input[name="reviewer_email"]').value.trim(),
        location: form.querySelector('input[name="location"]').value.trim(),
        honeypot: honeypotVal,
        recommend: form.querySelector('input[name="recommend"]:checked').value === 'true',
      };

      if (uploadedMediaUrls.length > 0) {
        payload.media_urls = uploadedMediaUrls;
      }

      var submitBtn = form.querySelector('.review-form__submit');
      submitBtn.disabled = true;
      submitBtn.textContent = 'Submitting...';

      fetch(apiBase + '/api/reviews/storefront', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Submission failed');
          return res.json();
        })
        .then(function () {
          form.style.display = 'none';
          successEl.style.display = '';
        })
        .catch(function (err) {
          errorEl.textContent = 'Something went wrong. Please try again.';
          errorEl.style.display = '';
          submitBtn.disabled = false;
          submitBtn.textContent = 'Submit Review';
        });
    });
  }

  // ── Boot ──

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
